<template>
    <div>
        <div v-if="showSearch" class="lw-cols learnworlds-input-wrapper with-input-cols align-items-stretch no-gutter one-row one-row-tl one-row-tp one-row-sl one-row-sp">
            <div class="col no-padding span_11_of_12 span_11_of_12-tl span_11_of_12-tp span_11_of_12-sl span_11_of_12-sp flex-item flexible">                
                <form @submit.prevent="">
                    <input class="lw-padding-very-small full-height learnworlds-input learnworlds-input-small learnworlds-input-outline-dark learnworlds-element"
                            :placeholder="i18n.get('common.search')"
                            type="text"
                            ref="searchInput"
                            @input="setSearchQuery"
                            >
                </form>
            </div>
            <div class="col no-padding span_1_of_12 span_1_of_12-tl span_1_of_12-tp span_1_of_12-sl span_1_of_12-sp flex-item flexible">
                <button class="only-icon learnworlds-button learnworlds-element full-size learnworlds-input-outline-dark learnworlds-button-small">
                    <span class="learnworlds-icon fas fa-search"></span>
                </button>
            </div>
        </div>
        <div v-if="showCategories" class="mt-20 lw-b-1px-fadeout80 lw-body-bg">
            <div class="lw-padding-very-small learnworlds-heading4-small learnworlds-heading4 no-margin-bottom">Categories</div>
            <div class="zebra-bg vertical">
                <div v-for="category in blogPostCategories" :key="category" class="lw-padding-very-small zebra-bg-item" @click="selectCategory(category.category)" :class="{selected: selectedCategory == category.category}">
                    <span class="learnworlds-main-text learnworlds-main-text-small">{{category.category}} ({{category.count}})</span>
                </div>                
            </div>
        </div>       
    </div>

</template>
<script>
export default {
    props:{
        blogPostCategories:{
            type: Array,
            default: []
        },
        selectedCategory:{
            type: String,
            default: ''            
        },
        showSearch: {
            type: Boolean,
            default: false
        },
        showCategories: {
            type: Boolean,
            default: false
        },
    },
    methods:{
        selectCategory(value){
            this.$emit('selectCategory', value)
        },
        setSearchQuery(value){
            this.$emit('setSearchQuery', value)
        }
    }
}
</script>